// Copyright ©️ 2026 eVolve MEP, LLC

import type { Product, ProductId } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';

import { LicenseIcon } from 'assets/icons/LicenseIcon';
import { PRODUCT_IDS } from 'constants/globalConstants';
import { EvolveProductCard } from 'modules/Admin/Licenses/LicensesMantine/EvolveProductCard';

export type InactiveProductCardProps = {
  product: Product;
};

const productLinkLookup: Record<ProductId, string> = {
  [PRODUCT_IDS.SHOP_LICENSE]: 'https://evolvemep.com/shop',
  [PRODUCT_IDS.ELECTRICAL_LICENSE]: 'https://evolvemep.com/electrical',
  [PRODUCT_IDS.MECHANICAL_LICENSE]: 'https://evolvemep.com/mechanical',
  [PRODUCT_IDS.SYNC_DESKTOP_LICENSE]: 'https://evolvemep.com/360-sync',
  [PRODUCT_IDS.MATERIAL_ANALYTICS]: 'https://evolvemep.com/professional',
  [PRODUCT_IDS.REVIT_USAGE_HISTORY]: 'https://evolvemep.com/professional',
  [PRODUCT_IDS.REVIT_ROLES]: 'https://evolvemep.com/professional',
  [PRODUCT_IDS.FABRICATION_LICENSE]: 'https://evolvemep.com/fabrication',
};

const DEFAULT_LINK = 'https://evolvemep.com/';

export const InactiveProductCard = ({ product }: InactiveProductCardProps) => {
  const learnMoreLink = productLinkLookup[product.productId] ?? DEFAULT_LINK;
  return (
    <EvolveProductCard
      title={product.productNameFormatted}
      icon={<LicenseIcon productId={product.productId} />}
      endSection={
        <Button variant="light" component="a" href={learnMoreLink} target="_blank">
          Learn more
        </Button>
      }
    />
  );
};
